export default __webpack_public_path__ + "static/media/preview-everland.e65bf810.jpg";